import ButtonDomFactory from '../../common/factory/button-dom-factory';
import TextAreaDomFactory, {
  TextAreaArgs,
} from '../../common/factory/text-area-factory';
import Builder from '../../common/builder/builder';
import { ButtonArgs } from '../../common/factory/button-dom-factory';

type Elements = {
  wrapper: HTMLElement;
  area?: HTMLTextAreaElement;
  label?: HTMLElement;
  button?: HTMLElement;
  error?: HTMLElement;
};

export default class TextAreaBuilder extends Builder<
  Elements,
  TextAreaDomFactory
> {
  private buttonFactory: ButtonDomFactory;

  constructor(factory: TextAreaDomFactory, buttonFactory: ButtonDomFactory) {
    super(factory);
    this.buttonFactory = buttonFactory;
  }

  public withArea({
    value,
  }: TextAreaArgs & { onChange?: (value: string) => void }) {
    this.elements.area = this.factory.createTextArea({
      placeholder: this.factory.i18n.t('Type your prompt'),
      value,
    });
    this.elements.wrapper.appendChild(this.elements.area);
    return this;
  }

  public withOnChange(onChange: (value: string) => void) {
    if (!this.elements.area) return this;
    const handler = (e: Event) => {
      onChange((e.target as HTMLTextAreaElement).value || '');
    };
    this.elements.area.addEventListener('input', handler);
    this.eventCleanup.push(() =>
      this.elements.area?.removeEventListener('input', handler),
    );
    return this;
  }

  public withLabel(text?: string) {
    this.elements.label = this.factory.createLabel(
      text || this.factory.i18n.t('Prompt'),
    );
    this.elements.wrapper.appendChild(this.elements.label);
    return this;
  }

  public withError(error?: string) {
    if (!error) return this;
    this.elements.error = this.factory.createMessageError(error);
    this.elements.wrapper.appendChild(this.elements.error);
    return this;
  }

  public withButton({ text, onClick, disabled }: ButtonArgs) {
    this.elements.button = this.buttonFactory.createButton({
      text,
      svg: '<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" /></svg>',
      disabled,
    });
    if (onClick) {
      this.elements.button.addEventListener('click', onClick);
      this.eventCleanup.push(() =>
        this.elements.button?.removeEventListener('click', onClick),
      );
    }
    this.elements.wrapper.appendChild(this.elements.button);
    return this;
  }
}
